import CM from 'sections/ApplicationForm/CM';
import QARD_SA from 'sections/ApplicationForm/QARD_SA';
import QARD_CA from 'sections/ApplicationForm/QARD_CA';
import CM_TD from 'sections/ApplicationForm/CM_TD';
import PlacementCMTD from 'sections/ApplicationForm/PlacementCMTD';

export const eApplicationForm = [
  {
    title: 'Download e-application forms and submit to us via email. Visit the branch only where necessary., e.g. to activate your account.',
    content: (
      <div className="text-grey-color">
        <p>Customer Declaration/Pengisytiharan Pelanggan:</p>
        <p>By submitting this Application Form, I confirm and agree that: / Dengan menyerahkan Borang Permohonan ini, saya mengesahkan dan bersetuju bahawa:</p>
        <ul>
          <li className="mt-3">Al Rajhi Banking & Investment Corporation (Malaysia) Bhd may collect, use and process my personal information set out in my application, and that I have read/understood and agreed to the contents of the <a href="/about/corporate-governance/compliance">Personal Data Protection Notice</a>; / Al Rajhi Banking & Investment Corporation (Malaysia) Bhd mungkin mengumpul, mengguna dan memproses data peribadi saya yang tercatat di dalam permohonan saya, dan saya telah membaca/memahami dan bersetuju dengan kandungan <a href="/about/corporate-governance/compliance">Notis Perlindungan Data Peribadi.</a></li>
          <li className="mt-3">I have read and understand the Product Terms & Conditions and wish to submit my application; / Saya telah membaca dan memahami Terma & Syarat Produk dan saya ingin untuk menyerahkan permohonan saya.</li>
          <li className="mt-3">I have access to download <a href="/static/media/PIDM_DIS.2b0c3071b3e3272e5836.pdf">PIDM's DIS brochure</a> and understand that this account is protected by PIDM up to RM250,000 for each depositor; / Saya telah mengakses untuk memuat turun <a href="/static/media/PIDM_DIS.2b0c3071b3e3272e5836.pdf">risalah PIDM DIS</a> dan memahami bahawa akaun ini dilindungi oleh PIDM setakat RM250,000 untuk setiap pendeposit.</li>
          <li className="mt-3">Al Rajhi Banking & Investment Corporation (Malaysia) Bhd can contact me via email and/or telephone for the purposes of completing this application. / Al Rajhi Banking & Investment Corporation (Malaysia) Bhd boleh menghubungi saya melalui emel dan/atau telefon untuk tujuan melengkapkan permohonan ini.</li>
        </ul>
      </div>
    )
  },
  {
    title: 'Commodity Murabahah Savings/Current Account-i/Foreign Currency Current Account-i',
    content: <CM />,
  },
  {
    title: 'Qard Savings Account-i',
    content: <QARD_SA />
  },
  {
    title: 'Qard Current Account-i',
    content: <QARD_CA />
  },
  {
    title: 'Commodity Murabahah Term Deposit Account-i (if you do not have an alrajhi bank Malaysia Savings/Current Account)',
    content: <CM_TD />,
  },
  {
    title: 'Placement of Commodity Murabahah Term Deposit-i (for existing alrajhi bank Malaysia Commodity Murabahah Term Deposit Account-i Customer Only)',
    content: <PlacementCMTD />,
  }
]